import classNames from 'classnames';
import React, { useState } from 'react';
import * as styles from './PostSectionHeader.module.scss';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import settingsIcon from '../icons/non-prefilled/16x16/settings.svg';

interface PostSectionHeaderProps {
  aboveTitle?: React.ReactNode;
  children: React.ReactNode;
  controls: React.ReactNode;
  fullPageWidth?: boolean;
}

const PostSectionHeader = ({
  aboveTitle = null,
  children,
  controls,
  fullPageWidth = true,
}: PostSectionHeaderProps) => {
  const [isShowingMobileControls, setIsShowingMobileControls] = useState(false);

  return (
    <div
      className={classNames(styles.header, {
        [styles.showMobileControls]: isShowingMobileControls,
        [styles.fullPageWidth]: fullPageWidth,
      })}
    >
      <div className={styles.content}>
        {!!aboveTitle && <div>{aboveTitle}</div>}
        <div>{children}</div>
      </div>
      {!!controls && (
        <div className={styles.controlsContainer}>
          <div className={styles.controls}>{controls}</div>
          <Button
            className={styles.mobileControlsToggle}
            onClick={() => setIsShowingMobileControls(!isShowingMobileControls)}
          >
            <SVGIcon>{settingsIcon}</SVGIcon>
          </Button>
        </div>
      )}
    </div>
  );
};

export default PostSectionHeader;
